/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./adssources/js/main.js":
/*!*******************************!*\
  !*** ./adssources/js/main.js ***!
  \*******************************/
/***/ (() => {

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function initFeaturedCaroussel() {
  var _$$owlCarousel;

  $('.featured-carousel').owlCarousel((_$$owlCarousel = {
    loop: true,
    autoplay: false,
    margin: 0,
    center: true,
    items: 3,
    mouseDrag: false,
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    nav: true,
    dots: false,
    autoplayHoverPause: false
  }, _defineProperty(_$$owlCarousel, "items", 1), _defineProperty(_$$owlCarousel, "navText", ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"]), _defineProperty(_$$owlCarousel, "responsive", {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    1000: {
      items: 3
    },
    1200: {
      items: 3
    }
  }), _defineProperty(_$$owlCarousel, "onTranslated", function onTranslated(vm) {
    $('.video_selector').removeClass("video_played").find('video').removeAttr("controls").trigger('load');
  }), _$$owlCarousel)); //video handler

  $(".owl_carousel-button").modalVideo({
    youtube: {
      controls: 0,
      autoplay: 1,
      mute: 1,
      showinfo: 0,
      start: 1,
      enablejsapi: 1
    },
    vimeo: {
      autoplay: true,
      controls: false
    }
  });
}

$(document).ready(function () {
  initFeaturedCaroussel();
});
document.addEventListener("shopify:section:load", function () {
  initFeaturedCaroussel();
});
$(document).on('click', '.owl_carousel-button', function () {
  setTimeout(function () {
    jQuery("iframe").each(function () {
      jQuery(this)[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  }, 500);
});
$(document).on('click', '.internal--video_play', function () {
  $(this).closest('.video_selector').addClass("video_played").find('video').eq(0).attr('controls', "controls").trigger('play');
}); // setTimeout(()=>{    
// },500)

$(document).on('click', '.internal--video_play', function () {
  $(this).closest('.video_selector').addClass("video_played").find('video').eq(0).attr('controls', "controls").trigger('play');
});
$(document).on('click', '.add_to_cart--handler', function () {
  $(this).closest('.product-item').find('button').eq(0).click();
  setTimeout(function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        openMiniCart: true
      }
    }));
  }, 500);
}); //add multiple element to the cart

$(document).on('click', '.add-multiple_product', function () {
  var vm = $(this);
  var items = $(this).attr("data-items").replaceAll("|id|", '"id"').replaceAll("|quantity|", '"quantity"').split(';'); //delete last element

  items = items.slice(0, -1);
  items = items.map(function (obj) {
    return JSON.parse(obj);
  });
  $(this).attr("aria-busy", true);
  $.post('/cart/add.js', {
    items: items
  }).done(function (items) {
    $(vm).attr("aria-busy", false);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        openMiniCart: true
      }
    }));
  });
});

function reloadCaroussel() {
  $('.main-product-carousel').owlCarousel({
    center: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    items: 2,
    loop: true,
    margin: 30,
    dots: false,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'><svg enable-background='new 0 0 197.402 197.402' version='1.1' viewBox='0 0 197.4 197.4' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'><polygon points='146.88 197.4 45.255 98.698 146.88 0 152.15 5.418 56.109 98.698 152.15 191.98' /></svg></div>", "<div class='nav-btn next-slide'><svg enable-background='new 0 0 197.402 197.402' version='1.1' viewBox='0 0 197.4 197.4' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'><polygon points='146.88 197.4 45.255 98.698 146.88 0 152.15 5.418 56.109 98.698 152.15 191.98' /></svg></div>"],
    responsive: {
      320: {
        items: 2,
        margin: 10
      },
      600: {
        items: 2
      }
    },
    onInitialized: function onInitialized() {
      if ($('.owl-item').first().hasClass('active')) $('.owl-prev').hide();else $('.owl-prev').show();
    }
  });
}

setTimeout(function () {
  reloadCaroussel();
}, 500);
document.addEventListener("shopify:section:load", function (event) {
  reloadCaroussel();
}); //close modal video item in collection list

function initModal(element) {
  $(element).modal({
    escapeClose: false,
    clickClose: false,
    showClose: true,
    fadeDuration: 150
  });
}

$('.main-close').click(function () {
  $(this).closest('.ADS_video-modal-popup').find('video').eq(0).trigger('load');
});
$(document).on('click', '.show__video', function () {
  reloadCaroussel();
  $($(this).attr('data-id')).find('.video-wrapper__play-button').eq(0).click();
  initModal(this);
});
$(".dynamicLink").click(function () {
  document.location.href = $(this).data("goto");
});
$(document).ready(function () {
  $('#register-customer').submit(function (event) {
    event.preventDefault();
    var data = $(this).serialize(); //create new account

    $.post('/account', data).done(function (data) {
      var logErrors = $(data).find('.errors').text(); //if there are errors show them in the html form

      if (logErrors != "" && logErrors != 'undefined') {
        $('#register-customer .errors').html(logErrors);
        $('#register-customer .errors').show(); //if account creation is successful show checkout page
      } else {
        console.log('success');
        document.location.href = '/pages/registration-success';
      }
    }).fail(function () {
      console.log('error');
    });
    return false;
  });
});
$(document).ready(function () {
  var searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has('vid')) {
    videoId = searchParams.get('vid');

    if (videoId.length > 0) {
      setTimeout(function () {
        $('html, body').scrollTop($('#' + videoId + '').offset().top);
        $('#' + videoId + ' a.video-wrapper__poster-content button').trigger('click');
      }, 1000);
      setTimeout(function () {
        // Selektiere das erste Videoelement in der Modal-Popup
        var videoElement = $('.ADS_video-modal-popup .product-list-with-video #' + videoId + ' .video_selector video')[0];

        if (videoElement) {
          videoElement.muted = true; // Ton stummschalten

          videoElement.play().then(function () {
            console.log('Modal Video spielt ab (ohne Ton)');
          })["catch"](function (error) {
            console.error('Fehler beim Abspielen:', error);
          });
        } // Selektiere Videoelemente anhand einer spezifischen ID


        var videoElementCollection = $('.product-list-with-video #' + videoId + ' video')[0];

        if (videoElementCollection) {
          //videoElementCollection.trigger('click'); // Klick auf die spezifizierten Videoelemente auslösen
          videoElementCollection.muted = true; // Ton stummschalten

          videoElementCollection.play().then(function () {
            console.log('Coellection Video spielt ab (ohne Ton)');
          })["catch"](function (error) {
            console.error('Fehler beim Abspielen:', error);
          });
        } // Ändere die CSS-Transparenz von bestimmten Produkt-Items


        $('.ADS_video-modal-popup .owl-stage-outer .owl-item .product-item').css('opacity', '1');
      }, 3000);
    }
  }
});

/***/ }),

/***/ "./adssources/scss/main.scss":
/*!***********************************!*\
  !*** ./adssources/scss/main.scss ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkperlenfischer"] = self["webpackChunkperlenfischer"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./adssources/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./adssources/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;